import type { PiggybankResponse } from '@konvert/shared';
import { formatDateRu } from '@konvert/domain';
import { t } from '../lib/i18n.js';

const KIND_NAMES: Record<string, string> = {
  task: 'задач',
  project: 'проектов',
  meeting: 'встреч',
  reminder: 'напоминаний',
  note: 'заметок',
};

export function PiggybankScreen({ data }: { data: PiggybankResponse }): JSX.Element {
  const counters: Array<[string, number]> = [
    [t('piggybank.today'), data.today],
    [t('piggybank.week'), data.week],
    [t('piggybank.month'), data.month],
    [t('piggybank.total'), data.total],
  ];

  return (
    <div className="space-y-4">
      <section className="envelope p-4">
        <h1 className="mb-3 text-lg text-ink">{t('piggybank.title')}</h1>
        <div className="grid grid-cols-2 gap-2">
          {counters.map(([label, value]) => (
            <div key={label} className="paper-card px-3 py-3">
              <p className="text-xs text-ink-soft">{label}</p>
              <p className="text-2xl text-ink">{value}</p>
            </div>
          ))}
        </div>
        {Object.keys(data.by_kind).length > 0 ? (
          <p className="mt-3 text-sm text-ink-soft">
            {t('piggybank.by_kind')}:{' '}
            {(Object.entries(data.by_kind) as Array<[keyof typeof KIND_NAMES, number]>)
              .map(([kind, count]) => `${KIND_NAMES[kind] ?? kind} ${count}`)
              .join(', ')}
            .
          </p>
        ) : null}

        {data.estimation_factor !== null ? (
          <p className="mt-3 text-sm text-ink-soft">
            {t('piggybank.factor')} {data.estimation_factor} раза — {data.estimation_sample}{' '}
            {t('piggybank.factor_sample')}.
          </p>
        ) : null}
      </section>

      <section className="space-y-2">
        {data.recent.map((card) => (
          <div key={card.id} className="paper-card px-3 py-2">
            <p className="text-[15px] text-ink">{card.is_private ? '[скрытая карточка]' : card.title}</p>
            <p className="text-xs text-ink-soft">
              {card.completed_at ? formatDateRu(card.completed_at.slice(0, 10)) : ''}
            </p>
          </div>
        ))}
      </section>
    </div>
  );
}
